export enum ModeOfTravelEnum {
    Scillonian,
    Skybus,
    FlyAndSail,
    SailAndFly,
    Unknown
}

export enum DirectionEnum {
    Return,
    Outward
}

export enum DestinationEnum {
    Unknown,
    StMarysAirport,
    LandsEnd,
    Exeter,
    NewQuay,
    PenzanceHarbour,
    StMarysHarbour
}

export enum PaxRuleEnum {
    Mandatory,
    MaxPerAdult,
    MaxAmount,
    MaxAmountPassengerType,
    Forbidden,
    Required
}

export enum PassengerTypeEnum {
    ShareholderAdult = "SHA",
  	Adult = "A",
    ShareholderYouth = "SHY",
  	Youth = "Y",
    ShareholderChild = "SHC",
    Child = "C",
    ShareholderInfant = "SHI",
    Infant = "I",
    Dog = "D"
}

export enum TicketTypeEnum {
    Standard,
    Flexi,
    Daytrip
}

export enum ExtraTypeEnum {
    None = 0,
    TravelInsurance = 1 << 0,
    Luggage	= 1 << 1,
    Bus	= 1 << 2,
    Pets = 1 << 3,
    Parking	= 1 << 4,
    Wheelchair = 1 << 5,
    DelayInsurance = 1 << 6,
    Charity	= 1 << 7,
    Cafe = 1 << 8,
    ExcessLuggage = 1 << 9,
    ExcessLuggageFooter = 1 << 10,
}

export enum TermTypeEnum {
    DangerousGoods,
    TravelId,
    ExcessLuggage,
    PetCrate,
}

export enum UserType {
    Unknown,
    Customer,
    Agent
}

export enum CustomerType {
    Default,
    Travelclub,
    Shareholder,
}

export enum Component {
    AccountLogin,
    AccountEmailCheck,
    AccountRegistration,
    AccountSettings,
    BookingExtraTermsCheckboxList,
    MyBookings,
    PassengerDetails,
    AccountForgotPassword,
    AccountResetPassword,
    AccountForm,
}

export enum BookingDataTypeEnum {
    Unknown = 0,
    Passenger = 1,
    Vehicle = 2,
    Accommodation = 4, // a cottage, not a cabin (see below)!
    Extras = 8,
    Transfer = 16,
    AddOn = 32,
    Cabin = 64,
    Fee = 128,
    Surcharge = 512,
    Ferry = Passenger | Vehicle | Cabin
}

export enum InsuranceConfirmationEnum {
    NeedInsurance,
    Proceed,
    Confirm,
    MainResidency,
    PolicyRequirement,
    DuplicateCover,
    MedicalCondition,
    ForbiddenActivity,
    ForbiddenActivityConfirm,
    InsuranceInformationProvided
}

export enum AmendmentOptionTypeEnum {
    Edit,
    CancelOutward,
    CancelReturn,
    CancelBooking
}

export enum CancellationTypeEnum {
    None = 0,
    Outward = 1 << 0,
    Return = 1 << 1
}

export enum AccommodationStateEnum {
    Calendar,
    AuthRequired,
    Details,
    Payment,
}